export const PERMISSION_MODULES = [
  { key: 'users', label: 'Users' },
  { key: 'companies', label: 'Companies' },
  { key: 'branches', label: 'Branches' },
  { key: 'customers', label: 'Customers' },
  { key: 'departments', label: 'Departments' },
  { key: 'industries', label: 'Industries' },
  { key: 'principals', label: 'Principals' },
  { key: 'product_categories', label: 'Product Categories' },
  { key: 'payment_terms', label: 'Payment Terms' },
  { key: 'roles', label: 'Roles' },
  { key: 'quotes', label: 'Quotes' },
  { key: 'po_sales', label: 'PO Sales' },
].map(module => ({ actions: ['view', 'add', 'edit', 'delete'], ...module }));

export const readSessionAdmin = () => {
  try {
    return JSON.parse(sessionStorage.getItem('quoteadmin') || 'null');
  } catch {
    return null;
  }
};

export const isSuperAdmin = admin => String(admin?.role_name || admin?.role?.name || '')
  .trim().toLowerCase() === 'super admin';

export const isVendorOwner = admin => admin?.is_vendor_owner === true || admin?.is_vendor_owner === 1;

export const allUserPermissions = () => Object.fromEntries(
  PERMISSION_MODULES.map(module => [module.key, [...module.actions]])
);

export const hasUserPermission = (module, action, admin = readSessionAdmin()) => {
  if (!admin?.id) return false;
  const definition = PERMISSION_MODULES.find(item => item.key === module);
  if (!definition?.actions.includes(action)) return false;
  if (isSuperAdmin(admin) || isVendorOwner(admin)) return true;
  // Existing accounts keep their current actions until the Vendor assigns permissions.
  if (admin.permissions == null) return true;
  return Array.isArray(admin.permissions[module]) && admin.permissions[module].includes(action);
};
